import React from "react"

import { Link } from "gatsby"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"
import "./NaturalOrganic.scss"

const NaturalOrganic = ({ section }) => {
  const url = section.image?.url
  const altText = section.image?.alt

  return (
    <section className="natural-organic">
      <section className="natural-organic__wrapper">
        <Fade>
          <div
            className="natural-organic__wrapper__description"
            style={
              section.backgroundColor && {
                backgroundColor: section.backgroundColor,
              }
            }
          >
            <div
              className="natural-organic__wrapper__description__text"
              style={
                section.textColor
                  ? {
                      color: section.textColor,
                    }
                  : null
              }
            >
              <p className="natural-organic__wrapper__description__text__top">
                {section.topText || "Lorem Ipsum"}
              </p>
              <p className="natural-organic__wrapper__description__text__title">
                {section.title || "Lorem Ipsum Title"}
              </p>
              <p className="natural-organic__wrapper__description__text__body">
                {section.description ||
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
              </p>
              <button
                className="natural-organic__wrapper__description__text__btn"
                style={
                  section.buttonBackgroundColor
                    ? {
                        backgroundColor: section.buttonBackgroundColor,
                      }
                    : null
                }
              >
                <Link
                  to={`/${section.buttonLink}`}
                  style={
                    section.buttonTextColor
                      ? {
                          color: section.buttonTextColor,
                        }
                      : null
                  }
                >
                  {section.buttonText || "Lorem Ipsum"}&nbsp;
                </Link>
              </button>
            </div>
          </div>
          <div className="natural-organic__wrapper__image">
            <img
              src={
                url ||
                "https://images.unsplash.com/photo-1640622658799-54e6039d189b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxMjF8fHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={altText}
              loading="lazy"
            />
          </div>
        </Fade>
      </section>
    </section>
  )
}

NaturalOrganic.propTypes = {
  section: PropTypes.object.isRequired,
}

export default NaturalOrganic
